import { render, staticRenderFns } from "./TrademarkPurchase.vue?vue&type=template&id=694d46b8&scoped=true"
import script from "./TrademarkPurchase.vue?vue&type=script&lang=js"
export * from "./TrademarkPurchase.vue?vue&type=script&lang=js"
import style0 from "./TrademarkPurchase.vue?vue&type=style&index=0&id=694d46b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d46b8",
  null
  
)

export default component.exports